var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 1920 1080",
    viewBox: "0 0 1920 1080",
    id: "bullseye",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#167ffc",
    d: "M508.3 1035.5c299.1 33 419.6 4.5 616.5 20 657.3 51.8 916.7-447.2 414.7-524.6-479.9-74-388.8-222.2-302.6-273.7C1323.1 205.7 1158.5.8 751.5 10c-106.9 2.4-495.1 1.6-573.7 190.3-241.1 579.4 31.4 802.1 330.5 835.2zM620.5 1066.3c0 6.7-90.9 12.8-203.1 13.6-112.2.8-203.2-4.1-203.2-10.8 0-6.7 90.9-12.8 203.1-13.6 112.2-.7 203.2 4.1 203.2 10.8z",
    opacity: 0.1,
    className: "color2a94f4 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3487ea",
    d: "M1634 1066.3c0 6.7-90.9 12.8-203.1 13.6-112.2.8-203.2-4.1-203.2-10.8 0-6.7 90.9-12.8 203.1-13.6 112.1-.7 203.1 4.1 203.2 10.8z",
    opacity: 0.1,
    className: "color34c3ea svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd8b1",
    d: "M676.5 151.3c-1-11.8-17.5-25-16.9-7.3 0 .7-.6 1.8-1.2 4.7-.6 2.4-1.5 5-2 7.5-.5 2.2-4 12.6-9.4 13.3-8.2 1-1.9-12.6-7.3-16.2-1.7-1.1-4.6 9.6-5.2 15.7-.7 6.1-1 9.2-.7 12.9.2 3.7 1.7 9 1.3 11.2-.8 3.5-5.5 10.4-5.5 10.4l20 6.4s5.8-10.8 8.5-13.2c6.7-5.6 11.2-12.4 14.3-20.8 1.9-5.2 2.9-10.8 3.8-16.3-.2.1.3-7.4.3-8.3z",
    className: "colorfcd2b1 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd8b1",
    d: "M469.8 304.9s64.7 5.1 103.3-31.2c31.5-36.8 62.3-77.8 64.7-81.7 5.3 2.6 16.7 9 16.7 9s-44.3 79.5-60.3 97.2C578 316 547 344.5 485.7 354.6c-25.8-35.5-15.9-49.7-15.9-49.7z",
    className: "colorfcd2b1 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9526",
    d: "M440.8 301c16.7-3.4 57.5 4.2 88.6-6.4 14.9 21.1 21.9 57.7 21.9 57.7s-42.6 22.1-72.2 22c-77.3 2.7-54.9-69.9-38.3-73.3z",
    className: "colorffbe55 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0d70",
    d: "M604.1 3.6h1.2v548.9h-1.2z",
    transform: "rotate(-62.6 604.763 278.05)",
    className: "color0b4870 svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9526",
    d: "m879.2 412.9-33.9-2.5c0-.4-5.3-39.4-31.4-88.6-24-45.2-71.1-108.7-159.2-154.1-88.4-45.6-164.8-45.6-213.2-37.5-52.1 8.7-83.4 27.9-83.7 28.1l-23-25.4c1.4-.9 46.1-16.5 102.8-25.9 52-8.6 133.7-8.7 227.9 39.8 94 48.5 144.2 116.5 169.8 165 27.7 52.8 43.6 99.4 43.9 101.1z",
    className: "colorffbe55 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd8b1",
    d: "M496.3 1024.7s3.7 8.5 3.5 14.2c-.2 5.7-18.3 6.9-20.6 4-2.2-2.9-4.4-29-4.4-29",
    className: "colorfcd2b1 svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0d70",
    d: "M474.7 1048.2c.2 5.9 2.3 15.6 2.3 15.6l20.9-.9.9-3.5s6.9 3.2 12.3 3l17.7-.7c12.9-.5 20.2-2.5 20.4-4.8 1-9.6-14.5-8.5-18.5-8.3-11.6.5-24.3-4.4-27.2-10.2-2.2-4.2-1.3-5.3-3.7-4.4 0 0-2.1.6-3.5 3.2-2 4.1-6.1 7-10.7 6.4-2.6-.3-5.3-1.2-7.2-3.1.1 0-3.9 1.7-3.7 7.7z",
    className: "color0b4870 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd8b1",
    d: "M291.9 1013.3s-3.2 15.5-5.5 20.7c-2.3 5.2-19.6-.4-20.6-3.9s6.7-28.6 6.7-28.6",
    className: "colorfcd2b1 svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0d70",
    d: "M259.6 1033.3c-2 5.6-4.8 16.4-4.8 16.4l16.3 8.8 3-2.5s3.7 5.5 8.7 8.4c3.7 2.1 11.8 5.1 16 5.9 14.6 2.7 25.8.7 26.8-1.4 4.4-8.5-14.9-12.3-18.7-13.6-10.9-3.8-16.2-14-16.9-20.5-.5-4.7.7-5.4-1.8-5.4 0 0-2.2-.3-4.4 1.7-3.4 3.1-8.3 4.3-12.3 2-2.3-1.3-4.4-3.1-5.5-5.6-.1.1-4.4.2-6.4 5.8z",
    className: "color0b4870 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M348.7 602.1s-31.2-66.9 16.3-118.4c0 0 43.1 17.2 77.1 18.1 26.8.7 40.2-2.6 40.2-2.6s8 49.3 8 127.2l-141.6-24.3z",
    className: "color494949 svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#595bd4",
    d: "M503.1 1024.1c-4.2-77.9 0-205.7.2-246 0-2.8-.2-5.4-.6-7.7.1-3.4-.1-7.1-.6-11-3-24.7-14.1-161.7-15.8-174.9-1.6-13.2-4.8-32.4-11.9-34.6-3.4-1-6.8-1.5-10.3-1.6-1.6-48.1-65.5-10.6-96.6 8.2-13.5 8.2-17.9 23.6-19.2 38.1-1 11.1-8.1 101.5-12.4 154.9-.8 7.4-4.3 28.9-19.2 55.6-3.5 5.4-6.6 11.2-9.3 17.3-24.9 58-31 139.9-42.1 187.8 18 6.7 29.2 8.1 29.2 8.1l1.7-4.8c24.5-74.1 71-178.5 85.9-216 1.3-3.2 2.1-6.1 2.7-8.9 5.7-19.9 19.6-57.7 34.2-97.6 10.6 39.4 23.6 84.3 31 103.6v.1c-1.9 9.2-3 19.1-3.5 29.6-3.2 67.5 19.3 157.8 26.6 207.8h2.5c17.7-.5 27.6-3 27.6-3l-.1-5z",
    className: "color0e538c svgShape"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5ca",
    d: "M450 264.8c-.5 4.1.3 20.3-8.3 24.2-8.6 3.9-14.1 5.6-13.9 6.9.1.6.9 3.5 1.9 6.2 2 6.3 5 7.8 5 7.8l1.2 20.7-15.5 15.4-5 5-7.6-6.9-24.8-22.4s10.2-12.6 3.2-26c-1-1.9-12.3-14.4-21.3-27-5.2-7.4-9.7-14.8-10.9-20-3.2-14.4-5.9-29.5 2.3-38.6 8.2-9 80.6-46.3 91.9-2.7.1 0 5.7 23.6 1.8 57.4z",
    className: "colorffe3ca svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0d70",
    d: "M385.1 247.4s12.5 7.3 14.5-11.1c.1-1 1-1.8 2.1-1.9 4.1-.4 13.6-3.4 12.5-21.7-.1-1.5 1.2-2.8 2.9-2.7 5.8.3 17.8 1 20.4 1.7 0 0 1.9.3 3.8 1 .6.2.9.8 1.3 1.2 1.8 2.2 5.5 5 5.8 5.9.4 1.3 3 11 3 11s1.7-1.5 1.7-4.8c-.1-3.3-3.2-10.4-2.5-12 .6-1.6 5.8-2.7 6.5-6.5 1.7-8.5 4.4-41.7-25.2-26.5-3.9 2-7.5 4.6-10.7 5.1-4.2.7-8.1-2.9-16.7-3.9-12-1.4-65.4 1-57.5 49.5 7.9 48.5 39.2 63.7 39.2 63.7s-7.3-43.2-1.1-48z",
    className: "color0b4870 svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5ca",
    d: "M383 247.8s-2.6-7.9-9.2-5.7c-8.9 3.1-8.1 25.5 11.3 22.5",
    className: "colorffe3ca svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9526",
    d: "M496.3 634.4s-80.9 9.3-169.3-7.1c4.3-27.3 14.4-125.8 15.5-157l.1-3.2c.7-19.9 1.1-34.1 1.5-34.7.9-1.2-2.3-64.7 3-89.5 1-4.6 2.2-7.8 3.8-9.1 10.3-8.6 22.5-17.6 36.1-24.3 0 0 29.5 33.5 45.6-4.1 17.7-1.6 37.3 14.1 42.5 31.8 28.4 98.7 21.2 297.2 21.2 297.2z",
    className: "colorffbe55 svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd8b1",
    d: "M331.6 432.3s13.6 46.9 49 69c10.3 6.4 23.2 2.8 31.3-6.2 24.2-27.1 48.4-88.1 56.2-111.2-14.2-7.5-18.7-6.4-18.7-6.4s-34.4 47.7-54.1 79.6l-14.7-25.7",
    className: "colorfcd2b1 svgShape"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd8b1",
    d: "M448.3 379.3s6.3-10.2 6.6-17.9c.3-7.7-3.4-21.1 4.1-28.1 2.8-2.6 20.7-25.1 31.7-23.3 16.4 2.7 11.5 17.8 10.6 21.2-.9 3.5-11.1 13-14 18.9-3 5.9-1.3 9.6-2.1 16-1.1 9.7-14.6 13.8-17.6 18.6-1.9 3.6-19.3-5.4-19.3-5.4z",
    className: "colorfcd2b1 svgShape"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9526",
    d: "M374.4 399.7c10.8 16.9 15.7 29.6 21.3 43.9-18.9 29.5-55 25.5-55 25.5s-20.8-45.9-19.6-77.3c1.6-40.7 38-64.5 38-64.5",
    className: "colorffbe55 svgShape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0d70",
    d: "M1501.8 1066.6h18.7l-100.1-772.7h-18.7zM1429.9 293.9h-18.7",
    className: "color0b4870 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b0d70",
    d: "M1405.6 293.9h18.7l-100.1 772.7h-18.8z",
    className: "color0b4870 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1422.4,
    cy: 422.2,
    fill: "#0b0d70",
    rx: 98.2,
    ry: 209.9,
    className: "color0b4870 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b0d70",
    d: "M1402.7 637.1c-28.3 0-54.5-22.8-73.9-64.3-18.9-40.3-29.2-93.7-29.2-150.5s10.4-110.2 29.2-150.5c19.4-41.5 45.7-64.3 73.9-64.3s54.5 22.8 73.9 64.3c18.9 40.3 29.2 93.7 29.2 150.5s-10.4 110.2-29.2 150.5c-19.4 41.4-45.7 64.3-73.9 64.3z",
    className: "color0b4870 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1402.7,
    cy: 422.2,
    fill: "#53d86a",
    rx: 98.2,
    ry: 209.9,
    className: "colorf7f7f7 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1401.7,
    cy: 422.2,
    fill: "#c18342",
    rx: 73.2,
    ry: 156.4,
    className: "colorc14242 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1400.7,
    cy: 422.2,
    fill: "#53d86a",
    rx: 45,
    ry: 96.1,
    className: "colorf7f7f7 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1400.2,
    cy: 422.2,
    fill: "#c18342",
    rx: 22,
    ry: 47,
    className: "colorc14242 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1398.2,
    cy: 422.2,
    fill: "#53d86a",
    rx: 6.2,
    ry: 13.3,
    className: "colorf7f7f7 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe9526",
    d: "M1140.1 417.9h237.7v8.8h-237.7z",
    className: "colorffbe55 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe9526",
    d: "m1377.8 436.7-24.6-14.5 24.6-14.4 24.6 14.4zM1158.6 422.2h-49l-18.5-18.6h49zM1158.6 422.2h-49l-18.5 18.7h49z",
    className: "colorffbe55 svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandMission);
export default __webpack_public_path__ + "static/media/land_mission.07af860f8d70a117132697a477ea3bc2.svg";
export { ForwardRef as ReactComponent };